// extracted by css-extract-rspack-plugin
export default {"container":"_64a386a5","hidden":"_8142aa8"};